<script>
    import { Link } from 'svelte-routing';
    import TopMenu from '../components/TopMenu.svelte';
    import Header from '../components/Header.svelte';
    import {store} from '../stores.js';

    const axis = store('axis', '', false);
</script>

{#if !$axis}
    <TopMenu title="Загрузка..." />
{/if}

<div id="appCapsule" class="{$axis ? 'pt-1' : ''}">
    <Header title="Загрузка..." />
    
    <div class="section">
        <div class="row">
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                Если зависло, можно вернуться <Link to="/dashboard">назад</Link>.
            </div>
        </div>
    </div>
</div>
